import styled from 'styled-components'
import { FormTxt } from 'atoms/Inputs'

export const SingleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 0.3;
  justify-content: center;
  /* max-width: 50px; */
`

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  margin-left: ${({ml}) => ml};
  flex: 1;
`

export const LeftLabel = styled.div`
  display: flex;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  flex: 1;
  background-color: ${({ theme }) => theme.mocaPurple};
  justify-content: center;
  align-items: center;
  height: ${({ height }) => (height ? height : '34px')};
  color: ${({ theme }) => theme.white};
`

export const RightInput = styled(FormTxt)`
  display: flex;
  width: 30%;
  border-color: ${({theme}) => theme.mocaGrey};
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  height: ${({ height }) => (height ? height : '34px')};
  padding: 9px 5px;
  flex: 3;

  &:disabled {
    background-color: ${({theme}) => theme.white};
  }
`
